import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../../components/layouts/Layout';

import {
  Stack,
  Typography,
  Box,
  Grid,
  Link,
  Tabs,
  Tab,
  Button,
} from '@mui/material';
import { AdminRoutes } from '../../routes/AdminRoutes';
import BrandDetails from '../../components/admin/compliance/brandDetails';
import VettingDetails from '../../components/admin/compliance/vettingDetails';
import Loader from '../../components/common/Loader';
import CustomerSelect from '../../components/admin/compliance/customerSelect';

import useComplianceRequest from '../../requests/ComplianceRequest';

const revetFields = [
  'company_name',
  'ein',
  'ein_issuing_country',
  'entity_type',
];

const optionNames =
  'vertical,altBusinessIdType,brandRelationship,entityType,usState,country,stockExchange,brandAppealCategory';
const BrandViewPage = ({
  errorHandler,
  accessLevel,
  accessType,
  navigate,
  location,
}) => {
  const [brand, setBrand] = useState({});
  const [options, setOptions] = useState({});
  const [isLoading, setLoading] = useState(false);
  const { getBrand, getOptions, getCustomerAccounts, updateBrandCustomers } =
    useComplianceRequest();
  const [tab, setTab] = useState('Brand');

  const { id } = useParams();

  const fetchBrand = async () => {
    try {
      setLoading(true);
      setBrand({});

      const data = await getBrand(id, errorHandler);
      const optionsResult = await getOptions(optionNames, errorHandler);

      console.log('brand data', data);

      setBrand(data);
      setOptions(optionsResult);
    } catch (e) {
      errorHandler(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBrand();
  }, [id]);

  const generateFormGroup = (label, displayValue, controlId, onClick) => {
    return (
      <Grid size={12}>
        <Typography>
          <strong>{label}</strong>{' '}
          {onClick ? (
            <Link tabIndex={0} onClick={onClick}>
              {displayValue}
            </Link>
          ) : (
            displayValue
          )}
        </Typography>
      </Grid>
    );
  };
  const generateCustomerInfo = () => {
    if (!brand) {
      return null;
    }

    return (
      <Box>
        <Grid container spacing={2}>
          {generateFormGroup(
            'Customer Name(s):',
            brand.customer_name || 'N/A',
            'customer_name'
          )}

          <Grid size={12}>
            <Typography>
              <strong>{'Account ID(s):'}</strong>{' '}
              <CustomerSelect
                previouslySelectedCustomers={brand.selectedAccountNos}
                onSubmit={async (selectedCustomers) => {
                  await updateBrandCustomers(
                    id,
                    selectedCustomers,
                    errorHandler
                  );
                  fetchBrand();
                }}
                requestFunction={() => getCustomerAccounts(id, errorHandler)}
                inputComponent={(onClick) => (
                  <Link tabIndex={0} onClick={onClick}>
                    {brand.customer_account_no}
                  </Link>
                )}
                fullWidth
              />
            </Typography>
          </Grid>

          {generateFormGroup(
            'Universal EIN:',
            brand.universal_ein || '',
            'universal_ein'
          )}
          {generateFormGroup(
            'Brand Code:',
            brand.brand_code || '',
            'brand_code'
          )}
          {generateFormGroup(
            'Brand Identity Status:',
            brand.brand_identity_status || '',
            'brand_identity_status'
          )}
        </Grid>
      </Box>
    );
  };

  return (
    <Layout
      title={'Brand Information'}
      routes={AdminRoutes}
      accessLevel={accessLevel}
      accessType={accessType}
      backButtonText={'Back'}
      handleBackButton={() => navigate(-1)}
      titleRowRightComponent={
        <Box>
          <Button
            onClick={() =>
              navigate('/admin/compliance/campaign', {
                state: { brandCode: brand.brand_code },
              })
            }
            variant="contained"
            color="secondary"
            disabled={!brand?.brand_code}
          >
            {'Add Campaign'}
          </Button>
        </Box>
      }
    >
      {isLoading ? (
        <Loader />
      ) : (
        <Stack gap={2}>
          {generateCustomerInfo()}
          <Box sx={{ borderBottom: 2, borderColor: 'divider' }}>
            <Tabs
              value={tab}
              onChange={(_, newValue) => {
                setTab(newValue);
              }}
              aria-label="compliance tabs"
            >
              <Tab
                label="Brand Details"
                value="Brand"
                sx={{ paddingTop: 0.5 }}
              />
              <Tab
                label="Vetting Details"
                value="Vet"
                sx={{ paddingTop: 0.5 }}
              />
            </Tabs>
          </Box>
          <Box>
            {tab === 'Brand' && (
              <BrandDetails
                navigate={navigate}
                errorHandler={errorHandler}
                brand={brand}
                options={options}
                fetchBrand={fetchBrand}
              />
            )}
            {tab === 'Vet' && (
              <VettingDetails
                brand={brand}
                errorHandler={errorHandler}
                options={options}
              />
            )}
          </Box>
        </Stack>
      )}
    </Layout>
  );
};

export default BrandViewPage;
